import {COPILOT_CHAT_SPEC_TASK_EVENT_TYPE} from './constants'

/**
 * Extracts the thread ID from a copilot-chat-spec-task event identifier.
 * Format: "copilot-chat-spec-task::{threadId}::{taskTag}"
 * Example: "copilot-chat-spec-task::thread-abc123::task-1" -> "thread-abc123"
 *
 * @param eventIdentifier - The event identifier string
 * @returns The thread ID, or undefined if not found
 */
export function extractSpecTaskThreadId(eventIdentifier: string): string | undefined {
  const prefix = `${COPILOT_CHAT_SPEC_TASK_EVENT_TYPE}::`
  const delimiter = '::'

  if (!eventIdentifier.startsWith(prefix)) {
    return undefined
  }

  // Remove the prefix
  const remainder = eventIdentifier.slice(prefix.length)

  // Split by delimiter to separate threadId from taskTag
  const delimiterIndex = remainder.indexOf(delimiter)
  if (delimiterIndex === -1) {
    return undefined
  }

  const threadId = remainder.slice(0, delimiterIndex)
  return threadId || undefined
}

/**
 * Extracts thread ID from any event identifier in a session or task.
 *
 * @param eventIdentifiers - Array of event identifiers from a session or task
 * @returns The thread ID, or undefined if not found
 */
export function extractSpecTaskThreadIdFromEventIdentifiers(eventIdentifiers?: string[] | null): string | undefined {
  if (!eventIdentifiers || eventIdentifiers.length === 0) {
    return undefined
  }

  // Check each event identifier for a copilot-chat-spec-task format
  for (const identifier of eventIdentifiers) {
    const threadId = extractSpecTaskThreadId(identifier)
    if (threadId) {
      return threadId
    }
  }

  return undefined
}
